import { Button, Input, Modal, Popconfirm, message } from 'antd';
import { FC, useState } from 'react';
import baseuri from '../../methods/baseuri';

interface IEditCron {
	item: any;
}
const ReverseCompletedWithdrawal: FC<IEditCron> = ({ item }) => {
	const [visible, setVisible] = useState(false);
	const [data, setData] = useState({
		title: item.title,
		requestId: item?._id,
		reverseCode: '',
	});

	const handleReverse = async () => {
		try {
			const res: any = await baseuri.post(
				`admin/wallet/reverse-completed-fiat-withdrawal`,
				data
			);
			if (res.status === 200) {
				message.success(res.data.message);
			} else {
				message.info(res.data.message);
			}
		} catch (e: any) {
			message.error(e.response.data.message);
		}
	};

	return (
		<>
			<Button onClick={() => setVisible(true)}>
				{Number(item?.status) === 2 ? 'Retry or Reverse' : 'Reverse Withdrawal'}
			</Button>

			<Modal
				title="Reverse Completed Withdrawal"
				visible={visible}
				footer={[
					<Popconfirm title="Are you sure?" onConfirm={handleReverse}>
						<Button type="primary">Reverse</Button>
					</Popconfirm>,
				]}
				onCancel={() => setVisible(false)}
			>
				<p>
					Revert{' '}
					<strong>
						{item.finalAmount} {item.currencyId?.symbol}
					</strong>{' '}
					for @{item?.userId?.username}
				</p>
				<br />
				<div style={{ marginBottom: '8px' }}>
					<p>Title</p>
					<Input.TextArea
						placeholder="input Title"
						value={data?.title}
						onChange={(e: any) => setData({ ...data, title: e.target.value })}
					/>
				</div>
				<div>
					<p>Reverse Code</p>
					<Input
						placeholder="reverse Code"
						value={data?.reverseCode}
						onChange={(e: any) =>
							setData({ ...data, reverseCode: e.target.value })
						}
					/>
				</div>
			</Modal>
		</>
	);
};

export default ReverseCompletedWithdrawal;
